import React, {useState} from "react";
import {HashLink as Link} from 'react-router-hash-link';
import {publicBuildUrl} from "../../../config/config";
import Modal from "../../Modal";
import { CgMoreVerticalO } from "react-icons/cg";

const Pootjes = () => {
    const [show, setShow] = useState({
        1: true
    });

    const toggle = (index) => {
        let state = {...show}
        state[index] = !(state[index] ?? false);
        setShow(state);
    };

    const Title = ({index, title}) => (
        <h3 onClick={() => toggle(index)} style={{cursor: "pointer"}}>
            <div style={{marginRight: '5px'}}>{title}</div>
            <div><CgMoreVerticalO /></div>
        </h3>
    )

    return (
        <Modal title={'HOE KAN JE CARE-FREE INZETTEN?'}
               image={'https://care-free.app/wp-content/uploads/2024/01/Hoowy_Pootjes_RolloverActive.png'}>
            <div>
                <h2>CARE-FREE</h2>

                <div>
                    <p>
                        <b>CARE-FREE</b> zet zich in voor iedereen die te maken krijgt met <b>kindermishandeling</b> door <b>kennis en ervaringsdeskundigheid</b> in te zetten voor <b>bewustwording, preventie</b> en <b>vroegtijdige signalering</b> van kindermishandeling. Het aanbod van <b>CARE-FREE</b> bestaat uit <b>gastlessen, trainingen, voorlichtingen</b> en <b>tools</b> voor kinderen, jongeren, (aankomend-) professionals en burgers.
                    </p>
                    <p>
                        Hieronder is <b>meer informatie</b> te vinden over de <b>tools en gastlessen van CARE-FREE</b>
                    </p>
                    {/*
                    <p className="p1">
                        De <strong>app CARE-FREE</strong> geeft <strong>informatie over kindermishandeling, waarom het gebeurt en wat je kunt doen als je zorgen hebt over jezelf of een ander</strong>.
                    </p>

                    <p className="p1">
                        De app CARE-FREE kan worden ge&iuml;ntroduceerd door de poster van CARE-FREE verspreid op te hangen op de locatie en gebruik te maken van de informatie waaier over de app CARE-FREE. Ook kunnen kinderen gewezen worden op het bestaan van de app CARE-FREE. Dit kan zowel 1-op-1 als in een grote groep. Door het kind te informeren zet je bewustwording in gang. Wanneer een kind niet weet hoe het na
                        de bewustwording kan praten over zijn/haar situatie kan het helpend zijn om het kind te wijzen op tips die in de app CARE-FREE staan om een situatie bespreekbaar te maken. Het kind kan vervolgens zelf kiezen op welke moment, met wie en hoe hij/zij de situatie wil bespreken.
                    </p>

                    <p className="p1">
                        Benoem tijdens de introductie van de app CARE-FREE regelmatig dat je er voor het kind bent wanneer hij/zij iets wil vertellen over een situatie waar het kind zich zorgen over maakt. Hierbij is het van belang dat je in contact bent met het kind, oprechte interesse hebt in het kind en geen oordeel hebt over zijn/ haar situatie, zodat het kind een veilige situatie heeft om zijn/ haar verhaal bespreekbaar te maken.
                    </p>

                    <div style={styles.container}>
                        <div>
                            <p className={'text'}>
                                <p className="p1"><strong style={{color: '#EC2867'}}>Download de gratis en anonieme app
                                    CARE-FREE: </strong></p>

                                <div style={{padding: '25px 0px 25px'}}>
                                    <a href={'https://play.google.com/store/apps/details?id=be.lucine_os.carefree'} target={'_blank'}>
                                        <img src={'https://care-free.app/wp-content/uploads/2021/11/GooglePlay.png'}
                                             style={{height: '110px'}}/>
                                    </a>

                                    <a href={'https://apps.apple.com/be/app/care-free/id1184394567?l=nl'} target={'_blank'}>
                                        <img src={'https://care-free.app/wp-content/uploads/2021/11/app-store.png'}
                                             style={{height: '110px'}}/>
                                    </a>
                                </div>
                            </p>
                        </div>
                    </div>
                    */}
                </div>


                <Title index={2} title={'GASTLES APP CARE-FREE'}/>
                {show['2'] && <div>
                    <p className="p1">
                        <strong>Duur: </strong>90 minuten<br/>
                        <strong>Doelgroep: </strong>Kinderen en jongeren van 10-18+<br/>
                        <strong>Doel: </strong>Kennismaken met het onderwerp kindermishandeling en de gratis en anonieme app CARE-FREE. De gratis en anonieme app CARE-FREE geeft informatie over kindermishandeling, waarom het gebeurt en wat je kunt doen als je zorgen hebt over jezelf of een ander.
                    </p>
                    <p className="p1">
                        <b>Voorafgaand</b> aan een gastles wordt door middel van <b>voorbereidingsvragen</b> en <b>voorwaarden</b> afgestemd met <b>de aanvrager</b> wat er nodig is om de les <b>veilig</b> en <b>prettig</b> te laten verlopen. Daarnaast wordt <b>het programma</b> doorgenomen. Indien gewenst kunnen hier <b>aanpassingen</b> in gemaakt worden <b>ten behoeve van de doelgroep</b>. CARE-FREE heeft ook <b>een voorbeeldbrief</b> ontwikkeld die gebruikt kan worden om <b>ouders/verzorgers te informeren</b> over de gastles.
                    </p>

                    <ul className="ul1">
                        <li className="li4"><a className={'download'} href={'https://care-free.app/wp-content/uploads/2024/01/Bijlage-1-Programma-Gastles-app-CARE-FREE.pdf'} target={'_blank'}>Programma | Gastles app CARE-FREE</a></li>
                        <li className="li4"><a className={'download'} href={'https://care-free.app/wp-content/uploads/2024/01/Bijlage-2-Voorbereiding-Gastles-app-CARE-FREE.pdf'} target={'_blank'}>Voorbereidingsvragen en voorwaarden | Gastles app CARE-FREE</a></li>
                        <li className="li4"><a className={'download'} href={'https://care-free.app/wp-content/uploads/2024/01/Bijlage-3-Voorbeeldbrief-Gastles-app-CARE-FREE.pdf'} target={'_blank'}>Voorbeeldbrief informeren ouder(s)/verzorger(s) | Gastles app CARE-FREE</a></li>
                    </ul>

                    <p className="p1">
                        <b>Tijdens</b> de gastles worden <b>geen persoonlijke ervaringen</b> van deelnemers besproken. Hier maken we in het begin van de gastles <b>duidelijke afspraken</b> over. Als een deelnemer iets herkent en <b>bespreekbaar wil maken</b> krijgt hij/zij hier <b>na de gastles</b> ruimte voor. Dit mag bij iemand van CARE-FREE of bij iemand anders die op dat moment zoals <b>afgesproken beschikbaar</b> is hiervoor. CARE-FREE zal <b>adviseren</b> en <b>ondersteunen</b> waar nodig/gewenst.
                    </p>

                    <p className="p1">
                        <b>Na</b> de gastles is CARE-FREE <b>minimaal 30 minuten</b> aansluitend aanwezig en <b>beschikbaar voor vragen</b> of als <b>iemand iets wil delen</b>. Als de situatie daarom vraagt blijft CARE-FREE langer aanwezig om te <b>adviseren</b> en/of te <b>ondersteunen</b>. Ook op een <b>later moment</b> mag de aanvrager <b>contact opnemen</b> met CARE-FREE om te overleggen als er <b>zorgen</b> zijn en/of <b>behoefte</b> is aan <b>advies</b> of <b>ondersteuning</b>.
                    </p>

                    <p className="p1"><strong>Wil je een impressie van een gastles? Bekijk dan onderstaande filmpjes:</strong></p>

                    <ul className="ul1">
                        <li className="li5"><span className="s4">
                            <a href="https://jeugdjournaal.nl/artikel/2406173-naomy-werd-als-kind-mishandeld-en-vertelt-erover-op-scholen" target={'_blank'}>https://jeugdjournaal.nl/artikel/2406173-naomy-werd-als-kind-mishandeld-en-vertelt-erover-op-scholen</a></span>
                        </li>
                        <li className="li5">
                            <span className="s3">
                                <a href="https://vimeo.com/644444771/d5ca859dc8" target={'_blank'}>https://vimeo.com/644444771/d5ca859dc8</a>
                            </span>
                        </li>
                    </ul>

                </div>}


                <Title index={3} title={'GASTLES GAME APP MIROCARES'}/>
                {show['3'] && <div>
                    <p className="p1">
                        <strong>Duur: </strong>120 minuten<br/>
                        <strong>Doelgroep: </strong>Kinderen en jongeren van 10-18+<br/>
                        <strong>Doel: </strong>Informatie krijgen over kindermishandeling en wat je kunt doen als je zorgen hebt door middel van de game-app MiroCares.
                    </p>

                    <p className="p1">
                        In de <b>game-app MiroCares</b> doorlopen deelnemers <b>de animaties</b> van <b>Milan, Milou en Mila</b>. Zij hebben met <b>verschillende vormen</b> van <b>kindermishandeling</b> te maken. Tijdens het spel krijgt de deelnemer op <b>een eigen device</b> vragen over wat er (feitelijk) te zien is op het gezamenlijke scherm, waardoor <b>de focus</b> op de juiste aspecten ligt. Vervolgens kunnen de deelnemers op hun <b>eigen device</b> met behulp van <b>een tool, inclusief criteria</b> en <b>uitleg, beoordelen</b> of de situatie <b>wel/niet ok&eacute;</b> is. <b>De tool</b> biedt jongeren de <b>veiligheid</b> en <b>geborgenheid</b> die zij nodig hebben om erachter te komen wat kindermishandeling is, waarom het gebeurt en wat je kunt doen als je zorgen hebt over jezelf of een ander. Aan het eind van een animatie wordt gevraagd wat zou kunnen <b>helpen</b> in de situatie, waardoor stil kan worden gestaan bij wat je kunt doen als je zorgen hebt over jezelf of een ander. Tijdens het spel worden <b>de juiste antwoorden</b> na iedere vraag op <b>het gezamenlijke scherm</b> zichtbaar en nabesproken.
                    </p>

                    <p className="p1">
                        <b>Voorafgaand</b> aan een gastles wordt door middel van <b>voorbereidingsvragen</b> en <b>voorwaarden</b> afgestemd met <b>de aanvrager</b> wat er nodig is om de les <b>veilig</b> en <b>prettig</b> te laten verlopen. Daarnaast wordt <b>het programma</b> doorgenomen. Indien gewenst kunnen hier <b>aanpassingen</b> in gemaakt worden <b>ten behoeve van de doelgroep</b>. CARE-FREE heeft ook <b>een voorbeeldbrief</b> ontwikkeld die gebruikt kan worden om <b>ouders/verzorgers te informeren</b> over de gastles.
                    </p>

                    <ul className="ul1">
                        <li className="li4"><a className={'download'} href={'https://care-free.app/wp-content/uploads/2024/01/Bijlage-1-Programma-Gastles-game-app-MiroCares.pdf'} target={'_blank'}>Programma gastles | Gastles Game app MiroCares</a></li>
                        <li className="li4"><a className={'download'} href={'https://care-free.app/wp-content/uploads/2024/01/Bijlage-2-Voorbereiding-Gastles-game-app-MiroCares.pdf'} target={'_blank'}>Voorbereidingsvragen en voorwaarden | Gastles Game app MiroCares</a></li>
                        <li className="li4"><a className={'download'} href={'https://care-free.app/wp-content/uploads/2024/01/Bijlage-3-Voorbeeldbrief-Gastles-game-app-MiroCares.pdf'} target={'_blank'}>Voorbeeldbrief informeren ouders/verzorgers | Gastles Game app MiroCares</a></li>
                    </ul>

                    <p className="p1">
                        <b>Tijdens</b> de gastles worden <b>geen persoonlijke ervaringen</b> van deelnemers besproken. Hier maken we in het begin van de gastles <b>duidelijke afspraken</b> over. Als een deelnemer iets <b>herkent</b> en <b>bespreekbaar wil maken</b> krijgt hij/zij hier <b>na de gastles</b> ruimte voor. Dit mag bij iemand van CARE-FREE of bij iemand anders die op dat moment zoals <b>afgesproken beschikbaar</b> is hiervoor. CARE-FREE zal <b>adviseren</b> en <b>ondersteunen</b> waar nodig/gewenst.
                    </p>

                    <p className="p1">
                        <b>Na</b> de gastles is CARE-FREE <b>minimaal 30 minuten</b> aansluitend aanwezig en <b>beschikbaar voor vragen</b> of als <b>iemand iets wil delen</b>. Als de situatie daarom vraagt blijft CARE-FREE langer aanwezig om te <b>adviseren</b> en/of te <b>ondersteunen</b>. Ook op een <b>later moment</b> mag de aanvrager <b>contact opnemen</b> met CARE-FREE om te overleggen als er <b>zorgen</b> zijn en/of <b>behoefte</b> is aan <b>advies</b> of <b>ondersteuning</b>.
                    </p>
                </div>}


                <Title index={10} title={'TRAINING/ VOORLICHTING'}/>
                {show['10'] && <div>
                    <p className="p1">
                        <strong>Duur: </strong>1 tot max. 3 uur.<br/>
                        <strong>Doelgroep: </strong>(Aankomend-) Professionals<br/>
                        <strong>Doel: </strong>Bewustwording, vroegtijdige signalering en preventie van kindermishandeling.
                    </p>

                    <p>
                        De <b>trainingen</b> en <b>voorlichtingen</b> van CARE-FREE zijn erop gericht om <b>kindermishandeling</b> (vroegtijdig) te <b>signaleren</b> en <b>zorgen bespreekbaar</b> te <b>maken</b> om uiteindelijk vanuit <b>gezamenlijke verantwoordelijkheid</b> een <b>weloverwogen beslissing</b> te kunnen nemen over de te nemen stappen volgens de <b>Meldcode als ‘Hulpcode’</b>. CARE-FREE biedt tevens tools aan die ook na de training of voorlichting nog te gebruiken zijn.
                    </p>

                    <p>
                        <b>De inhoud</b> van de training wordt altijd afgestemd op de <b>wensen en behoeften</b> van de <b>opdrachtgever</b> en <b>deelnemers</b>.
                    </p>
                </div>}

                <Title index={11} title={'Tools'}/>
                {show['11'] && <div>
                    <p>
                        CARE-FREE heeft verschillende tools ontwikkeld die bijdragen aan <b>bewustwording,
                        preventie</b> en <b>vroegtijdige signalering</b> van kindermishandeling.
                    </p>

                    <h4>APP CARE-FREE</h4>

                    <p>
                        De <b>app CARE-FREE</b> geeft <b>informatie over kindermishandeling, waarom het
                        gebeurt</b> en <b>wat je kunt doen als je zorgen hebt over jezelf of een ander</b>.
                    </p>

                    <p>
                        De <b>app CARE-FREE</b> kan worden geïntroduceerd door <b>de
                        poster</b> van <b>CARE-FREE</b> verspreid op te hangen op de locatie en gebruik te maken van
                        de <b>informatie waaier</b> over de app CARE-FREE. Ook kunnen kinderen gewezen worden op het
                        bestaan van de app CARE-FREE. Dit kan zowel <b>1-op-1</b> als in <b>groepsverband</b>. Door het
                        kind te <b>informeren</b> zet je <b>bewustwording</b> in gang. Wanneer een kind niet weet hoe
                        het na de bewustwording kan <b>praten</b> over zijn/haar situatie kan het <b>helpend</b> zijn om
                        het kind te wijzen op <b>tips</b> die in de app CARE-FREE staan om een <b>situatie bespreekbaar
                        te maken</b>. Het kind kan vervolgens <b>zelf kiezen</b> op welke moment, met wie en hoe hij/zij
                        de situatie wil <b>bespreken</b>.
                    </p>

                    <p>
                        <b>Benoem</b> tijdens de introductie van de app CARE-FREE regelmatig dat je <b>er voor het kind
                        bent</b> wanneer hij/zij iets wil vertellen over een situatie waar het kind zich zorgen over
                        maakt. Hierbij is het van <b>belang</b> dat je <b>in contact</b> bent met het kind, <b>oprechte
                        interesse</b> hebt in het kind en <b>geen oordeel</b> hebt over zijn/ haar situatie, zodat het
                        kind een <b>veilige situatie</b> heeft om zijn/ haar verhaal <b>bespreekbaar te maken</b>.
                    </p>

                    <p>
                        <b>Download de gratis en anonieme app CARE-FREE:</b>
                    </p>

                    <div style={{padding: '0px 0px 25px', marginLeft: '-12px'}}>
                        <a href={'https://play.google.com/store/apps/details?id=be.lucine_os.carefree'} target={'_blank'}>
                            <img src={'https://care-free.app/wp-content/uploads/2021/11/GooglePlay.png'}
                                 style={{height: '70px'}}/>
                        </a>

                        <a href={'https://apps.apple.com/be/app/care-free/id1184394567?l=nl'} target={'_blank'}>
                            <img src={'https://care-free.app/wp-content/uploads/2021/11/app-store.png'}
                                 style={{height: '70px'}}/>
                        </a>
                    </div>

                    <h4>GAME-APP MIROCARES</h4>

                    <p>
                        De <b>game-app MiroCares</b> geeft door middel van <b>spel</b> informatie <b>over
                        kindermishandeling</b> en wat je kunt <b>doen</b> als je <b>zorgen</b> hebt over <b>jezelf of
                        een ander</b>.
                    </p>

                    <p className="p1">
                        In de <b>game-app MiroCares</b> doorlopen deelnemers <b>de animaties</b> van <b>Milan, Milou en
                        Mila</b>. Zij hebben met <b>verschillende vormen</b> van <b>kindermishandeling</b> te maken.
                        Tijdens het spel krijgt de deelnemer op <b>een eigen device</b> vragen over wat er (feitelijk)
                        te zien is op het gezamenlijke scherm, waardoor <b>de focus</b> op de juiste aspecten ligt.
                        Vervolgens kunnen de deelnemers op hun <b>eigen device</b> met behulp van <b>een tool, inclusief
                        criteria</b> en <b>uitleg, beoordelen</b> of de situatie <b>wel/niet ok&eacute;</b> is. <b>De
                        tool</b> biedt jongeren de <b>veiligheid</b> en <b>geborgenheid</b> die zij nodig hebben om
                        erachter te komen wat kindermishandeling is, waarom het gebeurt en wat je kunt doen als je
                        zorgen hebt over jezelf of een ander. Aan het eind van een animatie wordt gevraagd wat zou
                        kunnen <b>helpen</b> in de situatie, waardoor stil kan worden gestaan bij wat je kunt doen als
                        je zorgen hebt over jezelf of een ander. Tijdens het spel worden <b>de juiste antwoorden</b> na
                        iedere vraag op <b>het gezamenlijke scherm</b> zichtbaar en nabesproken.
                    </p>

                    <p>
                        Na een <b>training</b> vanuit <b>CARE-FREE</b> is het ook mogelijk om de <b>game-app MiroCares
                        zelfstandig</b> in te zetten.
                    </p>

                    <h4>WERKVORM: LEREN SIGNALEREN</h4>

                    <p className="p1">
                        Hoe kun je signalen oppikken en wat doe je daar vervolgens mee? Bij het onderdeel &lsquo;Hoe kan
                        ik het herkennen?&rsquo; vind je 3 signalenlijsten terug met signalen bij kinderen van 0-4 jaar,
                        van 4-12 jaar en van 12-18 jaar. Deze signalenlijsten helpen om signalen eerder te herkennen en
                        om ook feitelijk te blijven. Wanneer je feitelijke signalen waar je zorgen over hebt
                        bespreekbaar kunt maken zul je ervaren dat het gesprek minder beladen wordt. Maak vanuit
                        gezamenlijke zorg, omdat je wil dat het goed gaat met die ander, zorgen bespreekbaar en vraagt
                        die ander of zij dat herkennen. Vervolgens kun je doorvragen op wat die ander daarover vertelt.
                        Je weet niet wat de reden voor zo&rsquo;n signaal is. Er kan ook een andere oorzaak voor zijn,
                        dat hoeft geen kindermishandeling te zijn. Je maakt het gesprek dan ook minder beladen omdat je
                        er niet vanuit hoeft te gaan dat er sprake is van kindermishandeling.
                    </p>

                    <p className="p3">
                        <strong>Oefenen met leren signaleren</strong><br/>
                        <span className="s1">Tip:</span> Doe deze opdracht samen met iemand anders zodat je achteraf
                        kunt vergelijken en de uitkomst kunt bespreken. Je zult in de animaties van Milan, Milou en Mila
                        meer signalen zien en horen dan normaal gesproken. Dit zorgt ervoor dat je extra uitgedaagd
                        wordt om niet in te vullen, maar feitelijk te blijven.
                    </p>

                    <ol className="ol1">
                        <li className="li1">Bekijk de animatie(s) van Milan, Mila en/of Milou.</li>
                        <li className="li1">Noteer (feitelijk) wat je ziet of hoort.</li>
                        <li className="li1">Download de <span
                            className="s2">
                            <a className={'download'}
                               href={'https://care-free.app/wp-content/uploads/2024/02/Hand-out-OeHoe-leren-Signaleren.pdf'}
                               target={'_blank'}>Checklist &lsquo;Leren Signaleren&rsquo;</a>
                            </span> om te controleren of je feitelijk de signalen hebt genoteerd die je kon
                            waarnemen. <span className="s1"><strong> </strong></span></li>
                        <li className="li1">Staat het er niet in? Ga dan voor jezelf na of het feitelijke informatie is.
                            Of heb je ingevuld hoe jij denkt dat het is?
                        </li>
                        <li className="li1">Bekijk de animatievideo nog eens. Hoe kijk je er nu naar?</li>
                    </ol>

                    <div className={'videos'}>
                        <div>
                            <b>Animatie Milan</b>
                            <video width={"50px"} controls>
                                <source
                                    src={'https://www.dropbox.com/scl/fi/o3z3hxv0nemewh8ibxgt0/Milan-Compleet.mp4?rlkey=gaql0r0q3lur3k21rgcy88y7d&raw=1'}
                                    type={'video/mp4'}/>
                            </video>
                        </div>
                        <div>
                            <b>Animatie Mila</b>
                            <video controls>
                                <source
                                    src={'https://www.dropbox.com/scl/fi/fanedns51gz2nesioawmv/Milou-Compleet.mp4?rlkey=ghfqnylnflhj6q8ufwlexs9yu&raw=1'}
                                    type={'video/mp4'}/>
                            </video>
                        </div>
                        <div>
                            <b>Animatie Milou</b>
                            <video controls>
                                <source
                                    src={'https://www.dropbox.com/scl/fi/m7rshlydybvdjgjfusbv3/Mila-Compleet.mp4?rlkey=9q27ubd81wf3g4lhywiht0z3m&raw=1'}
                                    type={'video/mp4'}/>
                            </video>
                        </div>
                    </div>

                    <h4>KENNISDATABANK: OE, HOE!?</h4>

                    <p>
                        <b>De kennisdatabank: Oe, Hoe!?</b> is ontwikkeld door <b>CARE-FREE</b> en biedt (aankomend-)
                        professionals een <b>digitaal</b> toegankelijk <b>overzicht</b> van <b>kennis,
                        diensten</b> en <b>producten</b> voor <b>bewustwording, preventie</b> en <b>vroegtijdige
                        signalering</b> van kindermishandeling.
                    </p>

                    <h4>TOOLBOX</h4>

                    <p>
                        <b>De Toolbox</b> van <b>CARE-FREE</b> geeft <b>informatie</b> over <b>kindermishandeling</b> en
                        wat je kunt doen als je zorgen hebt over jezelf of een ander met <b>bruikbare, praktische
                        tools</b> voor <b>bewustwording, preventie</b> en <b>vroegtijdige signalering</b> van
                        kindermishandeling.<br/>
                        <b>De toolbox</b> wordt regelmatig <b>geüpdatet/ aangevuld</b> met materiaal waarvan uit <b>de
                        praktijk</b> blijkt dat daar <b>behoefte</b> aan is.
                    </p>
                </div>}

                <div style={{marginBottom: '500px'}}></div>
            </div>
        </Modal>
    );
}

const styles =
    {
        container: {
            display: 'flex',
            justifyContent: 'flex-start'
        }
    }


export default Pootjes;
